module.exports = __webpack_public_path__ + "media/images/pic/pink-bird-070eca6e20e387d4084d0cf4f8a1fee7.svg";